import React, { useEffect, useState } from "react";

import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import Cookies from "js-cookie";

const Hello = () => {
  const [languageData, setLanguageData] = useState(null);
  const [userName, setUserName] = useState("");
  const [pseudo, setPseudo] = useState("");

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/dashboard/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);
  useEffect(() => {
    const dataUser = JSON.parse(
      localStorage.getItem(`${process.env.REACT_APP_USER_INFO}`),
    );
    const pseudo = dataUser.nickname;
    setPseudo(pseudo);
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  return (
    <>
      <div className="col-xl-12 mb-3 text-start">
        <h4 className="card-title">
          {languageData.hello}, {pseudo}
        </h4>
      </div>
    </>
  );
};

export default Hello;
